import React from 'react';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { bmwSideViewLeft } from '../../../images/landingLinks';
import { Link } from 'react-router-dom';

const WhyWait = () => (
  <div className="toronto-why-wait">
    <div className="toronto-why-wait__container">
      <div className="toronto-why-wait__left">
        <h2> Start drivesharing today.</h2>
        <div className="toronto-why-wait__requirements">
          <h5> Requirements:</h5>
          <div className="toronto-why-wait__requirements--condition">
            <FontAwesomeIcon
              icon={faCheck}
              fixedWidth
              size="1x"
              color="green"
            />
            <p>Must be at least 21 years old</p>
          </div>
          <div className="toronto-why-wait__requirements--condition">
            <FontAwesomeIcon
              icon={faCheck}
              fixedWidth
              size="1x"
              color="green"
            />
            <p>Have a valid driver’s license</p>
          </div>
          <Link to="/signup">
            <button className="toronto-why-wait__button">
              Sign up now
            </button>
          </Link>
        </div>
      </div>
      <div className="toronto-why-wait__right">
        <img
          className="toronto-why-wait__car"
          src={bmwSideViewLeft}
          alt="car"
        />
      </div>
    </div>
  </div>
);

export default WhyWait;



// WEBPACK FOOTER //
// ./src/components/Static/UberToronto/WhyWait.js